import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

const TimelineGraph = ({ filteredData }) => {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { eventName, time, value } = payload[0].payload;

      return (
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: "10px",
            borderRadius: "6px",
            boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
            width: "160px",
          }}
        >
          <div style={{ fontWeight: "bold", marginBottom: 6 }}>{eventName}</div>
          <div>Time: {time}</div>
          <div style={{ marginTop: 4 }}>
            Value: <strong>${value}</strong>
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <div style={{ width: "100%", height: 300 }}>
      <ResponsiveContainer>
        <LineChart data={filteredData}>
          <CartesianGrid
            horizontal
            vertical={false}
            stroke="rgba(228, 234, 240, 0.8)"
            strokeWidth={1}
          />

          {/* Top X-axis → Time */}
          <XAxis
            xAxisId="top"
            dataKey="time"
            orientation="top"
            tick={{ fill: "#666" }}
            axisLine={false}
            tickLine={false}
          />

          {/* Bottom X-axis → Event Name */}
          <XAxis
            xAxisId="bottom"
            dataKey="eventName"
            orientation="bottom"
            tick={{ fill: "#666", fontSize: 12 }}
            axisLine={false}
            tickLine={false}
          />

          <YAxis hide />

          <Tooltip
            content={<CustomTooltip />}
            cursor={{
              stroke: "#CBD5E1",
              strokeWidth: 1,
              strokeDasharray: "4 4",
            }}
          />

          <Line
            type="monotone"
            dataKey="value"
            stroke="#ff6b6b"
            strokeWidth={3}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TimelineGraph;
